/**
 * Feature gates read from the build-time env. Kept out of env.ts so tests that mock env.ts
 * with a partial object still get a working (off-by-default) answer here.
 */
import { env } from "./env";
import { gatewayOrigin } from "./mcp-gateway";

/** Whether the MCP Servers section (#939) is on in this build (REACT_APP_MCP_SERVERS_ENABLED). */
export function isMcpServersEnabled(): boolean {
  return env.REACT_APP_MCP_SERVERS_ENABLED === "true";
}

/**
 * Whether My Connections (#939, Feature H) is on in this build: REACT_APP_MY_CONNECTIONS_ENABLED
 * is "true" and REACT_APP_MCP_GATEWAY_URL names a gateway the page can frame. Without the gateway
 * there is nothing to show, so a build that sets only the flag keeps the feature off.
 */
export function isMyConnectionsEnabled(): boolean {
  return env.REACT_APP_MY_CONNECTIONS_ENABLED === "true" && gatewayOrigin() !== null;
}

/**
 * Whether the Skills & Plugins search points to matching MCP servers (#939, Feature I):
 * REACT_APP_MCP_CROSS_SEARCH_ENABLED is "true" and the MCP Servers section it points to is on.
 */
export function isMcpCrossSearchEnabled(): boolean {
  return env.REACT_APP_MCP_CROSS_SEARCH_ENABLED === "true" && isMcpServersEnabled();
}

/** Whether the Following section is on in this build (REACT_APP_FOLLOWING_ENABLED). */
export function isFollowingEnabled(): boolean {
  return env.REACT_APP_FOLLOWING_ENABLED === "true";
}
